"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownArrowIcon = DownArrowIcon;
const react_1 = __importDefault(require("react"));
function DownArrowIcon(extraProps) {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", ...extraProps },
        react_1.default.createElement("path", { d: "M 9.199 12.345 L 13.78 5.145 C 14.375 4.21 13.692 3 12.581 3 H 3.419 C 2.308 3 1.625 4.21 2.22 5.146 L 6.801 12.346 A 1.425 1.425 90 0 0 9.199 12.346 Z" })));
}
//# sourceMappingURL=down_arrow.js.map